import React, { useEffect, useState } from 'react';
import api from './api';

export default function AdminAuthPage({ onAuthSuccess }) {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth < 640 : false));

  useEffect(() => {
    function onResize() {
      setIsMobile(window.innerWidth < 640);
    }

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const { body, documentElement } = document;
    const root = document.getElementById('root');
    const prev = {
      htmlOverflow: documentElement.style.overflow,
      htmlHeight: documentElement.style.height,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyHeight: body.style.height,
      rootOverflow: root?.style.overflow || '',
      rootHeight: root?.style.height || '',
    };

    documentElement.style.overflow = 'auto';
    documentElement.style.height = 'auto';
    body.style.overflow = 'auto';
    body.style.position = 'static';
    body.style.height = 'auto';
    if (root) {
      root.style.overflow = 'visible';
      root.style.height = 'auto';
    }

    return () => {
      documentElement.style.overflow = prev.htmlOverflow;
      documentElement.style.height = prev.htmlHeight;
      body.style.overflow = prev.bodyOverflow;
      body.style.position = prev.bodyPosition;
      body.style.height = prev.bodyHeight;
      if (root) {
        root.style.overflow = prev.rootOverflow;
        root.style.height = prev.rootHeight;
      }
    };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await api.post('/auth/admin/login', {
        identifier,
        password,
      });
      onAuthSuccess(res.data.data);
    } catch (err) {
      setError(err?.response?.data?.message || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ ...styles.page, padding: isMobile ? 14 : 24 }}>
      <div style={{ ...styles.panel, padding: isMobile ? 20 : 32, borderRadius: isMobile ? 18 : 24 }}>
        {/* <div style={styles.kicker}>Administration</div> */}
        {/* <h1 style={{ ...styles.title, fontSize: isMobile ? 28 : 36 }}>Backgammon Admin</h1> */}
        {/* <div style={{ ...styles.subtitle, marginBottom: isMobile ? 18 : 24 }}>Authorized staff only</div> */}

        <form onSubmit={handleSubmit} style={styles.form}>
          <label style={styles.label}>
            Username or Email
            <input
              type="text"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              required
              style={{ ...styles.input, padding: isMobile ? 12 : 13, fontSize: isMobile ? 16 : 15 }}
            />
          </label>
          <label style={styles.label}>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ ...styles.input, padding: isMobile ? 12 : 13, fontSize: isMobile ? 16 : 15 }}
            />
          </label>

          {error && <div style={styles.error}>{error}</div>}

          <button type="submit" disabled={loading} style={{ ...styles.button, padding: isMobile ? 13 : 14 }}>
            {loading ? 'Checking...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'grid',
    placeItems: 'center',
    padding: 24,
    background: 'linear-gradient(180deg, #f8f1ea 0%, #f2e5d9 100%)',
  },
  panel: {
    width: '100%',
    maxWidth: 460,
    padding: 32,
    borderRadius: 24,
    background: 'rgba(255, 251, 247, 0.94)',
    border: '1px solid rgba(166, 106, 75, 0.14)',
    boxShadow: '0 32px 80px rgba(80,45,31,0.12)',
    color: '#241917',
  },
  kicker: {
    color: '#b8623f',
    textTransform: 'uppercase',
    letterSpacing: 1.8,
    fontSize: 12,
    fontWeight: 800,
    marginBottom: 10,
  },
  title: {
    margin: 0,
    fontSize: 36,
    fontWeight: 800,
  },
  subtitle: {
    color: '#7b665c',
    marginTop: 6,
    marginBottom: 24,
    fontSize: 14,
  },
  form: {
    display: 'grid',
    gap: 16,
  },
  label: {
    display: 'grid',
    gap: 8,
    color: '#54433c',
    fontSize: 14,
    fontWeight: 600,
  },
  input: {
    width: '100%',
    padding: 13,
    borderRadius: 12,
    border: '1px solid rgba(166, 106, 75, 0.14)',
    background: 'rgba(247, 241, 235, 0.94)',
    color: '#251916',
    outline: 'none',
    fontSize: 15,
  },
  error: {
    color: '#c95b46',
    fontSize: 14,
    borderRadius: 14,
    padding: '12px 14px',
    background: 'rgba(255, 243, 239, 0.95)',
    border: '1px solid rgba(201, 91, 70, 0.16)',
  },
  button: {
    border: '1px solid rgba(184, 105, 67, 0.26)',
    background: 'linear-gradient(145deg, #d68860, #b46642)',
    color: '#fffaf7',
    borderRadius: 12,
    padding: 14,
    fontWeight: 800,
    fontSize: 16,
    cursor: 'pointer',
    boxShadow: '0 16px 35px rgba(120,70,47,0.16)',
  },
};
